<div class="retracemntMenuContainer" #rMenu>
  <button [style.visibility]="'hidden'" mat-button [matMenuTriggerFor]="menu">Menu</button>
  <mat-menu #menu="matMenu">

    <button *ngIf="activeRetracement && !activeRetracement.expanded" (click)="expandeRetracement()" mat-menu-item>
      <mat-icon>fast_forward</mat-icon>
      <span>Expand</span>
    </button>

    <button *ngIf="activeRetracement && activeRetracement.expanded" (click)="collapseRetracement()" mat-menu-item>
      <mat-icon>fast_rewind</mat-icon>
      <span>Collapse</span>
    </button>

    <button (click)="closeRetracement()" mat-menu-item>
      <mat-icon>close</mat-icon>
      <span>Close</span>
    </button>
  </mat-menu>
</div>
